/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Capability_Market_Data_Illustration_AltInputs */

const en_landing_capability_market_data_illustration_alt = /** @type {(inputs: Landing_Capability_Market_Data_Illustration_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A wireframe globe with orbital rings representing global market data`)
};

/**
* | output |
* | --- |
* | "A wireframe globe with orbital rings representing global market data" |
*
* @param {Landing_Capability_Market_Data_Illustration_AltInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_capability_market_data_illustration_alt = /** @type {((inputs?: Landing_Capability_Market_Data_Illustration_AltInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Capability_Market_Data_Illustration_AltInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_capability_market_data_illustration_alt(inputs)
});